<template>
  <section>
    <Titulo
      :title="associado"
      description="Escolha as ações abaixo que deseja executar para o associado."
    />
    <div class="row">
      <div
        class="col-sm-6 col-md-4 col-lg-3"
        v-for="(produto, key) in produtos"
        :key="key"
      >
        <router-link
          class="text-center bg-white d-flex flex-column justify-content-center align-content-center pt-4 pb-5 mt-4 text-primary rounded"
          :to="produto.link"
          v-if="produto.active"
        >
          <div>
            <i class="material-icons text-warning mb-2">{{ produto.icon }}</i>
          </div>
          <div class="font-weight-bold h5">
            <span>{{ produto.titulo }}<br /></span>{{ produto.nome }}
          </div>
        </router-link>
      </div>
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          @click="$router.push({ name: 'gerenciarAssociados' })"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </section>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "consultorAssociados",
  components: { Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "Painel do Associado",
        id: "painelAssociado",
      },
      breadcrumb: [
        {
          nome: "CDL Consultor",
          id: "CDLConsultor",
          link: "/produto/cdl-consultor/minha-carteira",
        },
        {
          nome: "Painel do Associado",
          id: "painelAssociado",
        },
      ],
      produtos: [],
      associado: null,
    };
  },
  methods: {},
  created() {
    sessionStorage.removeItem("reserva");
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.produtos = [
      {
        nome: "Lista de Chamados",
        link: "/produto/cdl-consultor/chamados",
        icon: "fact_check",
        active: true,
      },
      {
        nome: "Editar Dados",
        link: "/produto/cdl-consultor/editar-associado",
        icon: "edit",
        active: true,
      },
      {
        titulo: "CDL Saúde",
        nome: "Gerenciar Vidas",
        link: "/produto/cdl-consultor/cdl-saude",
        icon: "person_add",
        active: true,
      },
    ];
    var codSocio = localStorage.getItem("associadoSelecionado");
    var dataSocio = this.$user.carteira.associados.filter(
      (el) => el.codSocio == codSocio
    );
    this.associado = dataSocio[0].nomeSocio;
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>

<style lang="scss" scoped>
.material-icons {
  font-size: 42px;
}
</style>
